import { navigate } from '@reach/router';
import {
  MultiDatePicker,
  MultiDatePicker_Range,
} from 'components/MyDatePicker/MultiDatePicker';
import cloneDeep from 'lodash/cloneDeep';
import React, { Component, MouseEvent } from 'react';
import { IRoleOption, IUserOption } from 'components/UserSelector/UserSelector';
import { batchAddMembersToCompanyFn } from 'store/companies/companiesSlice';
import {
  AssignmentType,
  DeleteState,
  ISearchParams,
  Order,
  Tab,
  TimeType,
} from 'store/entity/types';
import { searchTasksFn } from 'store/tasks/tasksSlice';
import {
  convertDigitToProperFormat,
  englishNumber,
  isANumber,
} from 'utils/number';
// import ClassicEditor from '@rastech-inc/ckeditor';
import Button from 'components/Button';
import UserSelector from 'components/UserSelector';
import SanitizedHTML from 'react-sanitized-html';
import required from 'assets/images/required.svg';
import Badge from 'components/Badge/Badge';
import CKEditorField, {
  CkEditorBaseConfig,
} from 'components/CKEditorField/CKEditorField';
import { ChipContainer } from 'components/Chip/Chip';
import Input from 'components/Input';
import notify from 'components/Notify';
import Select from 'components/Select';
import { IOption } from 'components/Select/Select';
import { Pill } from 'components/TaskListView/styles';
import { smartDateString } from 'utils/date';
import { combinePermission } from 'utils/permission';
import {
  absoluteBlack,
  black,
  gray,
  orange,
  red,
  stringToColour,
} from 'utils/style/colors';
import TaskConversation from '../Conversation/TaskConversation';
import messages from './Messages';
import SubtaskListContainer from './SubtaskListContainer';
import RelatedTasksComponent from './RelatedTasksComponent';
import { TaskAttachments } from './TaskAttachments/TaskAttachments';
import TaskFilePicker from './TaskFilePicker';
import { getTaskListAsHtml } from './TaskUtils';
import {
  ButtonActions,
  HighlightOverlay,
  InputValueWrapper,
  ProgressButton,
  SaveTaskActions,
  SubTaskListWrapper,
  TaskBody,
  TaskFooter,
  UsersList,
  WeightInput,
} from './styles';
import {
  getAllFieldOptions,
  HiddenFieldValue,
  IAssignmentHistory,
  IAssignmentView,
  IField,
  IRelatedTask,
  ITask,
  IUserTaskRelView,
  TaskStatus,
} from 'store/tasks/tasksType';
import { IPermission } from 'store/entity/IPermission';
import { ITasks, IUsers } from 'store/store';
import {
  ICompany,
  ICompanyProviders,
  IInvitedMember,
  IProjectMemberView,
  IProjectStore,
} from 'store/companies/companiesTypes';
import { IThisUserState } from 'store/thisUser/thisUserSlice';
import { IRelatedProviderItem } from 'store/providers/providerTypes';
import { WindowSize } from '../../../components/TaskListView/TaskListView';
import i18n, { languageDirection } from '../../../i18n';
import APopover from '../../../components/APopover/APopover';
import LocalIcon from '../../../ui/LocalIcon';
import { getLanguageBaseOnTZ } from '../../../utils/LanguageLocalStorage';
import VoiceToText from 'components/VoiceToText/VoiceToText';
import { buildDefaultFollowersFromProject } from 'store/tasks/taskManipulate2';

interface IComponentProps {
  companyId?: number;
  handleClickOnTask?: any;
  loadingSave: boolean;
  members: { [key: number]: IUserOption | IRoleOption };
  onSave: any;
  onUpdateAssignment?: (assignment: IAssignmentView) => any;
  onUpdateAssignmentHistoryList?: (
    assigneeId: number,
    assignmentHistory: IAssignmentHistory[]
  ) => any;
  onUpdateTask: (task: ITask) => void;
  onTaskCreate?: (task: number) => void;
  cancelEdit: () => void;
  parentId?: number;
  permission: IPermission;
  project?: IProjectStore;
  company?: ICompany;
  tab: Tab;
  embedded?: boolean;
  task: ITask;
  reFetchTask?: (id: number) => void;
  tasks: ITasks;
  users: IUsers['map'];
  templateName?: string;
  scrollToSubTask?: number;
  templates?: { data: ITasks['data'] };
  thisUser: IThisUserState;
  relatedTaskTemplate: ITask;
  foundDraftSubtask?: boolean;
  relatedProviders: ICompanyProviders | null;
  searchTasks: (params: ISearchParams) => ReturnType<typeof searchTasksFn>;
  editing: boolean;
  addMultipleMembersToCompany: (
    invitedMembers: IInvitedMember[],
    forceRename: boolean,
    companyId: number
  ) => ReturnType<typeof batchAddMembersToCompanyFn>;
  token?: string;
  setDirty: (id: number, dirty: boolean) => any;
  isDirty: boolean;
  safeNavigate?: any;
  selectedSubTaskId?: number;
  onDeleteTask: (taskId: number, taskName: string) => Promise<any>;
  onDraftTask: (task: ITask) => Promise<void>;
  notifyGuide: (type: string | string[]) => void;
  windowSize: WindowSize;
  onFileUploaded: () => void;
  showSettingsModal: () => void;
  assigneeIdToShow: number | null;
  onSetAssigneeIdToShow: (asId: number | null) => void;
}

export const makeReminderReadable = (reminder: number) => {
  let timeFormat = '';
  const day = Math.floor(reminder / 1440);
  const hour = Math.floor((reminder % 1440) / 60);
  const minutes = (reminder - day * 1440 - hour * 60) % 60;
  if (day) {
    timeFormat += i18n.t('day', {
      ns: 'taskManager',
      day: convertDigitToProperFormat(day),
    });
  }
  if (hour) {
    timeFormat += i18n.t('hour', {
      ns: 'taskManager',
      hour: convertDigitToProperFormat(hour),
    });
  }
  if (minutes) {
    timeFormat += i18n.t('minutes', {
      ns: 'taskManager',
      hour: convertDigitToProperFormat(hour),
    });
  }
  return timeFormat;
};

export const getMembershipInfo = (
  project: IProjectStore | undefined,
  value: IUserOption,
  company: ICompany,
  task: any
) => {
  const projectMembership = combinePermission(
    project!.projectMembers![value.userId.toString()],
    Object.values(project!.projectRoleMembers!),
    value.userId,
    Object.keys(company.members[value.userId].roles).map((it) => Number(it)) ||
      []
  );
  const assigneeMap = (task?.assignee || {}) as {
    [key: number]: IAssignmentView;
  };
  const currentAssignee =
    assigneeMap[value.userId] ||
    Object.values(assigneeMap).find(
      (assignee) => assignee.userId === value.userId
    );
  const roleIdFromProjectMembership =
    projectMembership?.relatedRoleId || projectMembership?.roleId;
  const roleNameFromProjectMembership =
    (roleIdFromProjectMembership &&
      company?.roles[roleIdFromProjectMembership]?.name) ||
    undefined;
  return {
    projectMembership,
    currentAssignee,
    roleIdFromProjectMembership,
    roleNameFromProjectMembership,
  };
};

interface IComponentState {
  showDateModal: 'none' | TimeType;
  task: ITask;
  highlightSubtasks?: boolean;
  assigneeChanged: boolean;
  dictating?: string;
  autoFillLoading: Set<string>;
  tab?: Tab;
  deletingTask?: boolean;
  draftingTask?: boolean;
  newRelatedTasks: IRelatedTask[];
  disableSendSMS: boolean;
}
const fixField = (task: ITask, _?: { [key: string]: any }) => {
  if (!task) return task;
  const ret = cloneDeep(task);
  ret.fields.forEach((field) => {
    if (field.type === 'html' && field.value)
      field.value = field.value.replaceAll(
        /<figure[^>]*>[^<]*<img>[^<]*<\/figure>/gi,
        ''
      );
  });
  return ret;
};
class TaskEditor extends Component<IComponentProps, IComponentState> {
  state: IComponentState = {
    showDateModal: 'none',
    task: fixField(this.props.task),
    assigneeChanged: false,
    dictating: undefined,
    autoFillLoading: new Set<string>(),
    newRelatedTasks: this.props.task.relatedTasks || [],
    disableSendSMS: false,
  };

  editors: { [key: string]: any } = {};

  private assigneeSectionRef = React.createRef<HTMLDivElement>();

  recognition = (() => {
    const SpeechRecognition =
      (window as any).webkitSpeechRecognition ||
      (window as any).SpeechRecognition;
    if (!SpeechRecognition) return undefined;
    const ret = new SpeechRecognition();
    ret.lang = 'fa';
    ret.continuous = true;
    ret.addEventListener('result', (event: any) => {
      const { dictating } = this.state;
      if (!dictating) return;
      const speechToText = event.results[event.resultIndex][0].transcript;
      const editors = this.editors;
      const editor = editors[dictating];
      editor.model.change((writer: any) => {
        const insertPosition =
          editor.model.document.selection.getFirstPosition();
        writer.insertText(speechToText, {}, insertPosition);
      });
    });
    ret.addEventListener('end', () => {
      this.setState({ dictating: undefined });
    });
    // ret.interimResults = true;
    return ret;
  })();

  listOfRequiredFields =
    this.props.task.draft || this.props.task.taskIsReadyToPublish
      ? []
      : this.props.task.requiredFields;

  checkRequiredFieldsFulfilled = () => {
    const task = this.state.task;

    const fieldMappings: { [key: string]: any } = {
      assignee: task.assignee,
      verifier:
        Object.keys(task.verifiers || {}).length > 0 ? task.verifiers : null,
      follower: task.followers,
      publisher: task.taskPublisher,
      subtaskPublisher: task.subTaskPublisher,
      startDate: task.startDate,
      dueDate: task.dueDate,
      relatedItem:
        (task.relatedProviderItems || []).length > 0
          ? task.relatedProviderItems
          : null,
    };

    return (
      this.listOfRequiredFields?.every((field) => fieldMappings[field]) ?? true
    );
  };

  componentDidMount() {
    this.notifyRelatedGuide();
    this.applyDefaultFollowersIfNeeded();
  }

  scrollToSubtasks = () => {
    document?.querySelector(`#subtask${this.props.task?.id}`)?.scrollIntoView({
      behavior: 'smooth',
    });
    setTimeout(() => {
      this.setState({ highlightSubtasks: true });
      setTimeout(() => {
        this.setState({ highlightSubtasks: false });
      }, 500);
    }, 500);
  };

  scrollToAssigneeSection = (userId: number) => {
    const scrollTarget = (element: Element | null | undefined) => {
      element?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    requestAnimationFrame(() => {
      scrollTarget(this.assigneeSectionRef.current);
    });

    window.setTimeout(() => {
      scrollTarget(this.assigneeSectionRef.current);
      scrollTarget(
        document.querySelector(`[data-assignee-user-id="${userId}"]`)
      );
    }, 250);
  };

  private applyDefaultFollowersIfNeeded = () => {
    const { project, company, users } = this.props;
    const task = this.state.task;
    if (
      task.id ||
      !task.followerDefaultToProjectMembers ||
      !project ||
      !company ||
      (task.followers && Object.keys(task.followers).length > 0)
    ) {
      return;
    }
    const followers = buildDefaultFollowersFromProject(
      project,
      users,
      company,
      task.followerCanEdit
    );
    if (Object.keys(followers).length === 0) {
      return;
    }
    this.setState((prevState) => ({
      task: {
        ...prevState.task,
        followers,
      },
    }));
  };

  componentDidUpdate(prevProps: Readonly<IComponentProps>): void {
    if (this.props.task.templateId !== prevProps.task.templateId)
      this.notifyRelatedGuide();

    const projectMembersBecameAvailable =
      !!this.props.project?.projectMembers &&
      Object.keys(this.props.project.projectMembers).length > 0 &&
      (!prevProps.project?.projectMembers ||
        Object.keys(prevProps.project.projectMembers).length === 0);

    if (projectMembersBecameAvailable) {
      this.applyDefaultFollowersIfNeeded();
    }

    if (
      prevProps.task.id === this.props.task.id &&
      prevProps.task.templateId === this.props.task.templateId && // when creating a task, id is null so we should check template and project
      prevProps.task.projectId === this.props.task.projectId
    ) {
      if (
        prevProps.task.draft !== this.props.task.draft ||
        prevProps.task.archived !== this.props.task.archived
      ) {
        this.setState({
          task: fixField(this.props.task),
        });
      }
      const currentAssigneeKeys = Object.keys(this.props.task.assignee || {});
      const prevAssigneeKeys = Object.keys(prevProps.task.assignee || {});
      const allAssigneeKeys = new Set([
        ...currentAssigneeKeys,
        ...prevAssigneeKeys,
      ]);
      const assigneeChanged = Array.from(allAssigneeKeys).some((key) => {
        const currentAssignee = this.props.task.assignee?.[Number(key)];
        const prevAssignee = prevProps.task.assignee?.[Number(key)];
        if (!currentAssignee && !prevAssignee) return false;
        if (!currentAssignee || !prevAssignee) return true;
        return (
          currentAssignee.progress !== prevAssignee.progress ||
          currentAssignee.status !== prevAssignee.status ||
          currentAssignee.progressDescription !==
            prevAssignee.progressDescription ||
          JSON.stringify(currentAssignee.taskFieldValues || {}) !==
            JSON.stringify(prevAssignee.taskFieldValues || {})
        );
      });
      if (assigneeChanged) {
        this.setState({
          task: fixField(this.props.task),
        });
      }
    } else {
      this.setState(
        {
          task: fixField(this.props.task),
          newRelatedTasks: this.props.task.relatedTasks || [],
        },
        () => {
          this.applyDefaultFollowersIfNeeded();
        }
      );
      this.recognition?.stop();
    }
    if (this.props.scrollToSubTask !== prevProps.scrollToSubTask) {
      this.scrollToSubtasks();
    }
    if (
      this.props.assigneeIdToShow !== null &&
      this.props.assigneeIdToShow !== prevProps.assigneeIdToShow &&
      (this.props.tab || 'info') === 'info'
    ) {
      this.scrollToAssigneeSection(this.props.assigneeIdToShow);
    }
  }

  private notifyRelatedGuide() {
    const templateTitle =
      this.props.tasks.data[this.props.task.templateId]?.taskName || '';
    if (this.props.permission.edit) {
      if (templateTitle === 'دستور جلسه' || templateTitle === 'جلسه') {
        this.props.notifyGuide([
          'ساخت دستور جلسه',
          'تایید دستور جلسه',
          'آموزش ارسال دستور جلسه',
          'ثبت حضور و غیاب افراد',
        ]);
      } else if (templateTitle === 'صورت جلسه') {
        this.props.notifyGuide([
          'ساخت صورت جلسه',
          'تایید صورتجلسه',
          'ارسال جهت امضا',
          'امضای صورتجلسه توسط افراد',
          'امضای صورتجلسه توسط یک نفر و ضمیمه کردن تصویر امضای گرم',
          'ابلاغ نهایی صورتجلسه',
          'پرینت صورتجلسه',
          'مشاهده مصوبات ابلاغ شده در اکانت شخصی',
          'پایش مصوبات و ثبت پیشرفت',
          'گزارش‌گیری کمیته',
        ]);
      } else if (templateTitle === 'برنامه عملیاتی') {
        this.props.notifyGuide([
          'ساخت برنامه عملیاتی',
          'مشاهده برنامه هر بخش',
          'مشاهده گام‌های محول شده به هر کس در اکانت خودش',
          'ثبت پیشرفت برنامه',
          'ضمیمه کردن اسناد به برنامه',
          'گزارش‌گیری برنامه',
        ]);
      }
    }
  }

  addEditor = (editor: any, name: string) => {
    this.editors[name] = editor;
  };

  static getDerivedStateFromProps(
    nextProps: IComponentProps,
    prevState: IComponentState
  ) {
    if (
      nextProps.task.id !== prevState.task.id ||
      nextProps.task.projectId !== prevState.task.projectId
    ) {
      return {
        task: nextProps.task,
        assigneeChanged: false,
      };
    }
    // on select a item in TaskFileExplorerModal
    if (
      prevState.task.relatedProviderItemId &&
      nextProps.task.relatedProviderItemId
    ) {
      const { id, providerId } = prevState.task.relatedProviderItemId;
      if (
        providerId !== nextProps.task.relatedProviderItemId?.providerId &&
        id === nextProps.task.relatedProviderItemId?.id
      ) {
        /*
          first condition get providerId from props
          second condition update selected item if its from another provider
        */
        return { task: nextProps.task, assigneeChanged: false };
      }
    }

    if (
      !nextProps.task.id &&
      nextProps.task.followerDefaultToProjectMembers &&
      Object.keys(nextProps.task.followers || {}).length > 0 &&
      Object.keys(prevState.task.followers || {}).length === 0
    ) {
      return {
        task: {
          ...prevState.task,
          followers: nextProps.task.followers,
        },
      };
    }

    return null;
  }

  handleDraftTask = () => {
    this.setState({ draftingTask: true });
    this.props.onDraftTask(this.props.task).finally(() => {
      this.setState({ draftingTask: false });
    });
  };

  handleDeleteTask = () => {
    const { task } = this.props;
    const taskTitle = `${task.taskName} ${task.textTitle}`;
    const confirm = window.confirm(
      messages.confirmDeleteATask(taskTitle, task.subTasksTitle)
    );
    if (confirm) {
      this.setState({ deletingTask: true });
      this.props.onDeleteTask(task.id, taskTitle).finally(() => {
        this.setState({ deletingTask: true });
      });
    }
  };

  onCancel = () => {
    if (this.props.embedded) {
      this.props.cancelEdit();
      return;
    }
    if (!this.props.task.template) {
      this.setState({
        task: fixField(this.props.task),
        assigneeChanged: false,
      });
      this.props.cancelEdit();
      return;
    }
    const { companyId, parentId, project, task } = this.props;
    let url = `/t/${companyId}/task`;
    if (project) {
      url = `/t/${companyId}/project/${project.id}/task`;
    }
    const safeParentId = parentId ? parentId : task.parentId;
    if (safeParentId) {
      url = `${url}/editor/${safeParentId}/info`;
    }
    navigate(url);
  };

  setDate = (value: {
    verifyDate?: number | null;
    startDate?: number | null;
    dueDate?: number | null;
  }) => {
    const task = cloneDeep(this.state.task);

    if (value?.verifyDate) {
      task['verifyDate'] = value.verifyDate;
    } else {
      task['verifyDate'] = undefined;
    }
    if (value?.startDate) {
      task['startDate'] = value.startDate;
    } else {
      task['startDate'] = undefined;
    }
    if (value?.dueDate) {
      task['dueDate'] = value.dueDate;
    } else {
      task['dueDate'] = undefined;
    }

    this.setState({
      task: { ...task },
      showDateModal: 'none',
    });
    this.setDirty();
  };

  handleInputChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const task = cloneDeep(this.state.task);
    if (event.target.name === 'title') {
      task.title = event.target.value;
    }
    if (event.target.name === 'weight') {
      task.weight = Number(event.target.value);
    }
    this.setState({ task });
    this.setDirty();
  };
  handleDraftChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const task = cloneDeep(this.state.task);
    task.draft = event.target.checked;
    this.setState({ task });
    this.setDirty();
  };
  handleTaskIsReadyToPublishChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const task = cloneDeep(this.state.task);
    task.taskIsReadyToPublish = event.target.checked;
    this.setState({ task });
    this.setDirty();
  };
  handleSubTasksAreReadyToPublishChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const task = cloneDeep(this.state.task);
    task.subTasksAreReadyToPublish = event.target.checked;
    this.setState({ task });
    this.setDirty();
  };
  handleChangeLock = (event: React.ChangeEvent<HTMLInputElement>) => {
    const task = cloneDeep(this.state.task);
    task.lockProps = event.target.checked;
    this.setState({ task });
    this.setDirty();
  };

  handleChangeFieldValues = (index: number, values: IOption[]) => {
    this.handleChangeFieldValue(
      index,
      values.reduce((current, item) => {
        if (current) current = current + ',';
        current = current + item.value;
        return current;
      }, '')
    );
  };

  handleFieldChangeEvent = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.handleChangeFieldValue(Number(event.target.name), event.target.value);
  };
  handleDateFieldChangeEvent = (
    fieldIndex: string,
    value: string | number | null
  ) => {
    this.handleChangeFieldValue(
      Number(fieldIndex),
      value ? (Number(value) + 12 * 60 * 60 * 1000).toString() : null
    );
  };

  handleChangeFieldValue = (index: number, value: string | null) => {
    const task = cloneDeep(this.state.task);
    if (task.fields[index]) {
      task.fields[index].value = value;
      this.setState({ task });
      this.setDirty();
    }
  };

  handleChangeProgress = (
    assigneeId: number,
    progress: string,
    status: TaskStatus,
    progressDescription: string
  ) => {
    const task = cloneDeep(this.state.task);
    task.assignee[assigneeId].progress = Number(progress);
    task.assignee[assigneeId].status = status;
    task.assignee[assigneeId].progressDescription = progressDescription;
    this.setState({ task, assigneeChanged: true });
    this.setDirty();
  };

  handleChangeVerifyProgress = (
    userId: number,
    progress: string,
    status: TaskStatus,
    progressDescription: string
  ) => {
    const task = cloneDeep(this.state.task);
    if (task.verifiers && task.verifiers[userId]) {
      task.verifiers[userId].progress = Number(progress);
      task.verifiers[userId].status = status;
      task.verifiers[userId].progressDescription = progressDescription;
    }
    this.setState({ task, assigneeChanged: true });
    this.setDirty();
  };

  setDirty = (isDirty: boolean = true) => {
    if (isDirty) {
      this.props.setDirty(this.state.task.id || 0, isDirty);
      this.props.safeNavigate?.handleChangeDirty?.(isDirty);
    }
  };

  getLatestAssignmentHistory = (
    progressList: IAssignmentHistory[],
    assigneeId: number
  ) => {
    return progressList
      .filter(
        (item) => item.assignmentId === assigneeId && item.state !== 'Delete'
      )
      .sort((a, b) => {
        const aTime =
          a.updateDate instanceof Date
            ? a.updateDate.getTime()
            : Number(a.updateDate);
        const bTime =
          b.updateDate instanceof Date
            ? b.updateDate.getTime()
            : Number(b.updateDate);
        return bTime - aTime;
      })
      .at(0);
  };

  calculateMainProgress = (
    progressList: IAssignmentHistory[],
    assigneeId: number
  ) => {
    return (
      this.getLatestAssignmentHistory(progressList, assigneeId)?.progress ?? 0
    );
  };

  handleSetAssignmentHistory = (
    assignmentHistoryList: IAssignmentHistory[]
  ) => {
    const newAssignee = { ...this.state.task.assignee };
    Object.values(newAssignee).forEach((as) => {
      const latestHistory = this.getLatestAssignmentHistory(
        assignmentHistoryList,
        Number(as.id)
      );

      if (latestHistory) {
        newAssignee[Number(as.userId)] = {
          ...newAssignee[Number(as.userId)],
          progress: Number(latestHistory.progress ?? 0),
          status: latestHistory.status,
          progressDescription: latestHistory.progressDescription,
        };
      }
    });

    this.setState({
      task: {
        ...this.state.task,
        assignmentHistoryList,
        assignee: newAssignee,
      },
      assigneeChanged: true,
    });
    this.setDirty();
  };

  handleSave = () => {
    if (this.checkRequiredFieldsFulfilled()) {
      if (this.state.task.title && this.state.task.title.length > 0) {
        const taskToSave = {
          ...this.state.task,
          relatedTasks: this.state.newRelatedTasks,
        };

        if (
          !this.props.editing &&
          this.state.assigneeChanged &&
          !this.props.permission.edit
        ) {
          const assignmentId = Object.values(this.state.task.assignee).find(
            (key) => key.userId === Number(this.props.thisUser.userId)
          )?.id;
          const assignmentHistory = this.state.task.assignmentHistoryList;
          this.props
            ?.onUpdateAssignmentHistoryList?.(
              Number(assignmentId),
              assignmentHistory
            )
            ?.then(() => {
              this.setDirty(false);
              this.setState({ assigneeChanged: false });
            });
        } else
          this.props
            .onSave(taskToSave, false, false, this.state.disableSendSMS)
            .then(() => {
              this.setDirty(false);
              this.setState({ assigneeChanged: false });
            });
      }
    } else {
      notify(i18n.t('requiredFields', { ns: 'taskManager' }), 'error');
    }
  };
  deleteAttachment = (id: number) => {
    const task = cloneDeep(this.props.task);
    const find = task.attachments?.find((it) => it.id === id);

    if (find) {
      find.deleted = true;
      return this.props.onSave(task, false, true);
    }
  };

  handleChangeAssignee = (values: Array<IUserOption | IRoleOption>) => {
    const task = cloneDeep(this.state.task);
    const { project, company } = this.props;
    if (task) {
      const previousAssignees = task.assignee || {};
      task.assignee = values.reduce((list: ITask['assignee'], value) => {
        if (value.optionType === 'user') {
          const {
            projectMembership,
            currentAssignee,
            roleIdFromProjectMembership,
            roleNameFromProjectMembership,
          } = getMembershipInfo(project, value, company!, task);
          const existingAssignee =
            currentAssignee ||
            previousAssignees[value.userId] ||
            Object.values(previousAssignees).find(
              (assignee) => assignee.userId === value.userId
            );
          list[value.userId] = {
            ...existingAssignee,
            userId: value.userId,
            status: existingAssignee?.status ?? value.status ?? 'notStarted',
            type: 'does',
            progress: existingAssignee?.progress ?? value.progress ?? 0,
            progressDescription:
              existingAssignee?.progressDescription ??
              value.progressDescription,
            id: existingAssignee?.id ?? value.assignmentId,
            taskId: task!.template ? undefined : (task!.id as number),
            properties: {
              roleId: value.relatedRoleId || roleIdFromProjectMembership,
              roleName: value.relatedRoleName || roleNameFromProjectMembership,
              implicit: projectMembership?.implicit,
              title: projectMembership?.title,
              projectRoleId: projectMembership?.projectRoleId,
            },
          };
        }
        return list;
      }, {});
      this.setState({ task, assigneeChanged: true });
      this.setDirty(true);
    }
  };

  handleChangeVerifiers = (values: Array<IUserOption | IRoleOption>) => {
    const task = cloneDeep(this.state.task);
    const { project, company } = this.props;
    if (task) {
      task.verifiers = values.reduce((list: ITask['verifiers'], value) => {
        if (value.optionType === 'user') {
          const {
            projectMembership,
            currentAssignee,
            roleIdFromProjectMembership,
            roleNameFromProjectMembership,
          } = getMembershipInfo(project, value, company!, task);
          list[value.userId] = {
            userId: value.userId,
            status: currentAssignee ? currentAssignee.status : 'notStarted',
            type: 'verify',
            progress: currentAssignee ? currentAssignee.progress : 0,
            taskId: task!.template ? undefined : (task!.id as number),
            properties: {
              roleId: value.relatedRoleId || roleIdFromProjectMembership,
              roleName: value.relatedRoleName || roleNameFromProjectMembership,
              implicit: projectMembership?.implicit,
              title: projectMembership?.title,
              projectRoleId: projectMembership?.projectRoleId,
            },
          };
        }
        return list;
      }, {});
      this.setState({ task });
      this.setDirty(true);
    }
  };

  handleChangeFollowers = (values: Array<IUserOption | IRoleOption>) => {
    const task = cloneDeep(this.state.task);
    task.followers = values.reduce((list: IUserTaskRelView[], value) => {
      if (value.optionType === 'user') {
        const user = Object.values(task.followers).find(
          (follower: IUserTaskRelView) => follower.userId === value.userId
        );
        const item: IUserTaskRelView = {
          userId: value.userId,
          taskId: task.template ? undefined : (task.id as number),
          canEdit: user ? user.canEdit : task.followerCanEdit,
        };
        list.push(item);
      }
      return list;
    }, []);
    this.setState({ task });
    this.setDirty();
  };

  handleChangeVerifier =
    (type: AssignmentType, field: 'taskPublisher' | 'subTaskPublisher') =>
    (values: Array<IUserOption | IRoleOption>) => {
      const { project, company } = this.props;
      const task = cloneDeep(this.state.task);
      let verifier: IAssignmentView | null = null;
      if (values.length !== 0 && values[0].optionType === 'user') {
        const userValue = values[0] as IUserOption;
        const {
          projectMembership,
          roleIdFromProjectMembership,
          roleNameFromProjectMembership,
        } = getMembershipInfo(project, userValue, company!, task);
        verifier = {
          userId: userValue.userId,
          status: userValue.status ? userValue.status : 'notStarted',
          type: type,
          progress: userValue.progress ? userValue.progress : 0,
          taskId: task.template ? undefined : (task.id as number),
          properties: {
            roleId: userValue.relatedRoleId || roleIdFromProjectMembership,
            roleName:
              userValue.relatedRoleName || roleNameFromProjectMembership,
            implicit: projectMembership?.implicit,
            title: projectMembership?.title,
            projectRoleId: projectMembership?.projectRoleId,
          },
        };
      }
      task[field] = verifier;
      this.setState({ task, assigneeChanged: true });
      this.setDirty();
    };

  handleClickOnDate =
    (dateType: 'none' | TimeType, editable: boolean) => () => {
      if (editable) {
        this.setState({ showDateModal: dateType });
      }
    };

  handleRemoveDate = (dateType: TimeType) => () => {
    this.setState((prevState) => {
      const task = cloneDeep(prevState.task);
      task[dateType] = undefined;
      return { task, showDateModal: 'none' };
    });
    this.setDirty();
  };

  handleSaveRelatedProviderItems = (providerItem: IRelatedProviderItem) => {
    const task = cloneDeep(this.state.task);
    const relatedProviderItems = task.relatedProviderItems;
    if (relatedProviderItems) {
      task.relatedProviderItems = [...relatedProviderItems, providerItem];
    } else {
      task.relatedProviderItems = [providerItem];
    }
    this.setState({ task });
    this.setDirty();
  };

  handleRemoveProviderItem =
    (item: IRelatedProviderItem) => (e: MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      const task = cloneDeep(this.state.task);
      const relatedProviderItems = task.relatedProviderItems;
      if (relatedProviderItems) {
        task.relatedProviderItems = relatedProviderItems.filter(
          (relatedItem) => relatedItem.id !== item.id
        );
        this.setState({ task });
        this.setDirty();
      }
    };

  handleSetAllProgressComplete = (status: TaskStatus) => {
    const task = cloneDeep(this.state.task);
    const progress = status === 'complete' ? 100 : status === 'started' ? 1 : 0;
    const now = Date.now();
    const actorId = Number(this.props.thisUser.userId);
    const historyEntries: IAssignmentHistory[] = [];

    // Always re-key by userId so later assignee edits can resolve existing progress
    task.assignee = Object.values(task.assignee || {}).reduce(
      (assigneeMap: ITask['assignee'], assignee) => {
        if (assignee.progress !== progress || assignee.status !== status) {
          historyEntries.push({
            id: Math.random(),
            assignmentId: assignee.id,
            userId: assignee.userId,
            actorId,
            taskId: task.id,
            updateDate: now,
            status,
            type: 'does',
            progress,
            progressDescription: '',
            lastEditDate: now,
            state: 'Add',
          });
        }
        assigneeMap[assignee.userId] = {
          ...assignee,
          status,
          progress,
        };
        return assigneeMap;
      },
      {}
    );

    if (historyEntries.length > 0) {
      task.assignmentHistoryList = [
        ...(task.assignmentHistoryList || []),
        ...historyEntries,
      ];
    }

    this.setState({ task, assigneeChanged: true });
    this.setDirty();
  };

  toggleDictation(key: string) {
    const { dictating } = this.state;
    let wait = false;
    if (dictating === key || dictating !== null) {
      this.recognition?.stop();
      wait = true;
      this.setState({ dictating: undefined });
    }
    if (dictating !== key) {
      setTimeout(
        () => {
          this.setState({ dictating: key });
          this.recognition.start();
          const editor = this.editors[key];
          if (editor) editor.sourceElement.focus();
        },
        wait ? 500 : 1
      );
    }
  }

  getChildTemplateId = () => {
    if (!this.props.templates) {
      return (
        Object.values(this.props.company?.templates || {}).find(
          (it: any) => it.taskId === this.props.task.templateId
        ) as any
      )?.children[0];
    }
    return Object.keys(this.props.templates.data)[0];
  };

  getLastSiblingItem = async (
    order: Order,
    refDate: 'effectiveDate' | 'creationDate'
  ) => {
    const { task, tasks } = this.props;
    let parentTask = task.parentId && tasks.data[task.parentId];
    let parentTaskTemplate: number;
    let parentTaskEffectiveDate: number | undefined = undefined;
    let parentTaskProjectId: number;
    let usingSelfAsParent = false;
    if (!parentTask) {
      parentTaskTemplate = task.templateId;
      // parentTaskEffectiveDate = task[refDate]!;
      parentTaskProjectId = task.projectId;
      parentTaskProjectId = task.projectId;
      usingSelfAsParent = true;
      parentTask = task;
    } else {
      parentTaskTemplate = parentTask.templateId;
      parentTaskEffectiveDate = parentTask[refDate]!;
      parentTaskProjectId = parentTask.projectId;
    }
    const fieldValues = parentTask.fields
      .filter((it) => it.configs?.includes('checkInFindPreviousTask'))
      .reduce(
        (current, item) => {
          current[item.name!] = item.value ?? '';
          return current;
        },
        {} as { [key: string]: string }
      );
    const uncle = await this.props
      .searchTasks({
        companyId: this.props.companyId,
        projectId: parentTaskProjectId,
        templateId: Number(parentTaskTemplate), // creationDate
        toDate: isANumber(parentTaskEffectiveDate)
          ? parentTaskEffectiveDate! - 10
          : undefined, //
        order: order,
        includeDrafted: false,
        archived: false,
        fieldValues,
        count: 1,
      })
      .then(({ tasks }) => tasks);
    if (uncle.length === 0) return undefined;
    if (usingSelfAsParent) return uncle[0];
    const parentId = uncle[0].id;
    const sibilings = await this.props
      .searchTasks({
        companyId: this.props.companyId,
        projectId: this.props.project!.id,
        parentId: parentId,
      })
      .then(({ tasks }) => tasks);
    return sibilings.length === 0 ? undefined : sibilings[0];
  };
  calculateFieldValue = async (
    field: IField,
    done: (result: string | undefined) => void
  ) => {
    const childTemplateId = this.getChildTemplateId();
    if (!childTemplateId) {
      done(undefined);
      return;
    }
    const baseSearchParams = {
      companyId: this.props.companyId,
      projectId: this.props.project!.id,
      templateId: childTemplateId!,
      archived: false,
      deleteState: 'notDeleted' as DeleteState,
      count: 100,
      includeDrafted: false,
    };
    let promise: Promise<ITask[]>;
    let title = '';
    if (field.autoFillFunc === 'AllSibling_NotStarted') {
      promise = this.props
        .searchTasks({
          ...baseSearchParams,
          mainProgressFrom: 0,
          mainProgressTo: 0,
        })
        .then(({ tasks }) => tasks);
    } else if (field.autoFillFunc === 'AllSibling_Started') {
      promise = this.props
        .searchTasks({
          ...baseSearchParams,
          mainProgressFrom: 1e-5,
          mainProgressTo: 100 - 1e-5,
        })
        .then(({ tasks }) => tasks);
    } else if (
      field.autoFillFunc &&
      (field.autoFillFunc as string).startsWith('LastSibling')
    ) {
      if (field.autoFillFunc === 'LastSibling_NextNumber') {
        const LastSibling = await this.getLastSiblingItem(
          'creationDate_desc',
          'creationDate'
        );
        done(
          convertDigitToProperFormat(
            Number(
              englishNumber(
                LastSibling?.fields?.find(
                  (it: IField) => it.name === field.name
                )?.value || '0'
              )
            ) + 1
          )
        );
        return;
      }
      const LastSibling = await this.getLastSiblingItem(
        'dueDate_desc',
        'effectiveDate'
      );
      if (LastSibling) {
        let mainProgressFrom: number = 0;
        let mainProgressTo: number = 100;
        switch (field.autoFillFunc) {
          case 'LastSibling_NotStarted':
            mainProgressFrom = 0;
            mainProgressTo = 0;
            break;
          case 'LastSibling_Started':
            mainProgressFrom = 1e-5;
            mainProgressTo = 100 - 1e-5;
            break;
          case 'LastSibling_Done':
            mainProgressFrom = 100;
            mainProgressTo = 100;
            break;
          case 'LastSibling_All':
            mainProgressFrom = 0;
            mainProgressTo = 100;
            break;
        }
        promise = this.props
          .searchTasks({
            ...baseSearchParams,
            mainProgressFrom: mainProgressFrom,
            mainProgressTo: mainProgressTo,
            parentId: LastSibling.id,
          })
          .then(({ tasks }) => tasks);
        title = i18n.t('from', {
          ns: 'taskManager',
          item: LastSibling.title,
        });
      } else {
        done(undefined);
        return;
      }
    } else {
      done(undefined);
      return;
    }
    promise.then((result: ITask[]) => {
      const filteredResult = result.filter(
        (it) => it.parentId !== this.props.task?.id
      );
      if (filteredResult.length === 0) {
        done(undefined);
        return;
      }
      const resultString =
        this.props.companyId &&
        getTaskListAsHtml(
          filteredResult.sort((a: any, b: any) => {
            const effectiveCompare = a.effectiveDate - b.effectiveDate;
            return effectiveCompare === 0
              ? a.order - b.order
              : effectiveCompare;
          }),
          this.props.users,
          true,
          true,
          true,
          this.props.companyId
        );
      done((title ? `<p>${title}</p>` : '') + resultString);
    });
  };
  autoFill = (index: number, field: IField) => {
    this.state.autoFillLoading.add(field.name);
    this.setState({ autoFillLoading: this.state.autoFillLoading });
    this.calculateFieldValue(field, (result: string | undefined) => {
      if (result) this.handleChangeFieldValue(index, result);
      else notify(i18n.t('noMatchFound', { ns: 'taskManager' }), 'warning');
      this.state.autoFillLoading.delete(field.name);
      this.setState({ autoFillLoading: this.state.autoFillLoading });
    });
  };

  findTargetUserToAlert(userRole: string) {
    if (userRole === 'verifier') {
      return (
        this.props.task.verifierTitle ||
        i18n.t('conformers', { ns: 'taskManager' })
      );
    } else if (userRole === 'publisher') {
      return (
        this.props.task.taskPublisherTitle ||
        i18n.t('publishers', { ns: 'taskManager' })
      );
    } else if (userRole === 'assignee') {
      return (
        this.props.task.assigneeTitle ||
        i18n.t('assignees', { ns: 'taskManager' })
      );
    } else if (userRole === 'subTaskPublisher') {
      return (
        this.props.task.subTaskPublisherTitle ||
        i18n.t('subtasksPublishers', { ns: 'taskManager' })
      );
    } else {
      // this for follower
      return (
        this.props.task.followersTitle ||
        i18n.t('follower', { ns: 'taskManager' })
      );
    }
  }

  findTargetTimeTitleToAlert(time: string) {
    if (time === 'dueDate') {
      return (
        this.props.task.dueDateTitle || i18n.t('dueDate', { ns: 'taskManager' })
      );
    } else if (time === 'verifyDate') {
      return (
        this.props.task.verifyDateTitle ||
        i18n.t('verifyDate', { ns: 'taskManager' })
      );
    } else {
      // for startDate
      return (
        this.props.task.startDateTitle ||
        i18n.t('startDate', { ns: 'taskManager' })
      );
    }
  }

  calcTimeToAlert(minutes: number) {
    const time = makeReminderReadable(Math.abs(minutes));
    return minutes > 0
      ? i18n.t('afterTime', { ns: 'taskManager', time: time })
      : i18n.t('beforeTime', { ns: 'taskManager', time: time });
  }

  render() {
    const {
      companyId,
      onUpdateTask,
      permission,
      tab: propTab,
      task,
      templates,
      loadingSave,
      members,
      handleClickOnTask,
      // templateName,
      onUpdateAssignment,
      editing,
      project,
      relatedProviders,
      relatedTaskTemplate: {
        assigneeTitle,
        dueDateTitle,
        followersTitle,
        startDateTitle,
        subTasksTitle,
        verifierTitle,
        taskPublisherTitle,
        subTaskPublisherTitle,
        relatedProviderItemTitle,
        haveRelatedItem,
      },
      foundDraftSubtask,
      windowSize,
    } = this.props;
    const {
      task: {
        readyToPublishSubTaskTitle,
        readyToPublishTaskTitle,
        taskIsReadyToPublish,
        subTasksAreReadyToPublish,
        draft,
        assignee,
        dateAndTime,
        dueDate,
        conversationId,
        fields,
        followers,
        haveDueDate,
        haveFollower,
        haveAssignee,
        haveStartDate,
        haveVerifier,
        haveTaskPublisher,
        haveSubTaskPublisher,
        haveVerifyDate,
        template,
        lockMark,
        startDate,
        title,
        type,
        verifiers,
        taskPublisher,
        subTaskPublisher,
        verifyDate,
        relatedProviderItems,
        weight,
        reminderInfos,
      },
      assigneeChanged,
      autoFillLoading,
      tab: stateTab,
    } = this.state;
    // reminders configuration
    const remindersConfig = reminderInfos.reduce((acc: any[], item) => {
      return [
        ...acc,
        {
          sendTo: this.findTargetUserToAlert(item.target),
          targetTime: this.findTargetTimeTitleToAlert(item.timeTarget),
          time: this.calcTimeToAlert(item.offsetM),
        },
      ];
    }, []);

    const tab = stateTab || propTab;

    let projectMembersId: number[] | undefined;
    if (project) {
      const memberIdsSet = Object.values(project.projectMembers || {})!.reduce(
        (memberIds: Set<number>, member: IProjectMemberView) => {
          if (!member.implicit) {
            memberIds.add(member.userId!);
          }
          return memberIds;
        },
        new Set<number>()
      );
      Object.values(project.projectRoleMembers || {})!.reduce(
        (memberIds: Set<number>, member: IProjectMemberView) => {
          if (!member.implicit) {
            this.props.company?.roles[member.roleId!]?.users?.forEach((r) => {
              memberIds.add(r.userId);
            });
          }
          return memberIds;
        },
        memberIdsSet
      );
      projectMembersId = Array.from(memberIdsSet);
    }
    const saveButtonTitle =
      subTasksAreReadyToPublish && editing
        ? messages.saveAndReadyToPublishSubTask(
            task.readyToPublishSubTaskTitle,
            task.subTasksTitle
          )
        : taskIsReadyToPublish && editing
          ? messages.saveAndReadyToPublishTask(
              task.readyToPublishTaskTitle,
              task.taskName
            )
          : draft && editing
            ? i18n.t('saveDraft', { ns: 'taskManager' })
            : editing
              ? i18n.t('save', { ns: 'taskManager' })
              : i18n.t('saveProgress', { ns: 'taskManager' });

    // Edits (assignee history, progress, fields) live in state.task; props.task stays as loaded from parent until save/refetch
    const imTask = this.state.task;
    const hasEmptyRequiredField = fields?.find(
      (field) =>
        field.required &&
        ((editing && !field.relatedToProgress) ||
          (assigneeChanged && field.relatedToProgress)) &&
        (!field.value || /^\s*$/.test(field.value))
    );
    const fieldClass =
      windowSize === 'small'
        ? 'col s12 l12 m12'
        : windowSize === 'medium'
          ? 'col s6 m6 l6'
          : 'col s4 m4 l4';
    const fieldElements = this.getFieldElements(
      fields,
      editing,
      autoFillLoading,
      task,
      project,
      assigneeChanged,
      fieldClass
    );
    const showSubTasksArReadyToPublishCheckbox =
      !template &&
      ((((task.draft && !haveTaskPublisher) ||
        (!(task.draft && haveTaskPublisher) && foundDraftSubtask)) &&
        haveSubTaskPublisher) ||
        subTasksAreReadyToPublish);
    const showLockCheckbox =
      editing &&
      !template &&
      !task.draft &&
      task.autoLockOnPublish &&
      !task.lockProps &&
      !showSubTasksArReadyToPublishCheckbox;
    const showTaskIsReadyPublishCheckbox =
      !template && task.draft && haveTaskPublisher;

    const taskHasSMSHandler =
      (task.notificationProperties.notifyWithSMS === 'ActionRequired' ||
        task.notificationProperties.fieldNotifications.find(
          (el) => el.notifyWithSMS
        )) &&
      (task.draft
        ? task.notificationProperties.fieldNotifications.find(
            (el) => el.notifyWhenDraft
          )
        : true);

    return (
      <div className="flex flex-col w-full overflow-y-auto flex-1">
        {editing && permission.edit ? (
          <div
            style={{
              marginInlineEnd: '15px',
              marginInlineStart: '15px',
              marginTop: '5px',
              marginBottom: '5px',
              fontWeight: 'bold',
              display: 'flex',
            }}
          >
            <div
              style={{
                width: '100%',
              }}
            >
              <CKEditorField
                key={`title-${task.taskName}`}
                id="title"
                // editor={ClassicEditor}
                data={task.title || ''}
                onChange={(data: string) => {
                  const task = cloneDeep(this.state.task);
                  task.title = data.replaceAll(
                    /<(?!\/?(span|mark)(?=>|\s.*>))\/?.*?>/g,
                    ''
                  );
                  this.setState({ task });
                  this.setDirty();
                }}
                language={getLanguageBaseOnTZ()}
                dir={languageDirection()}
                config={{
                  toolbar: { items: ['fontColor', 'highlight', '|', 'speech'] },
                  language: getLanguageBaseOnTZ(),
                  placeholder: i18n.t('taskTemplateName', {
                    ns: 'taskManager',
                    templateName: task.taskName,
                  }),
                }}
              />
            </div>
            {task.haveWeight && (
              <WeightInput
                id="weight"
                type="number"
                step="any"
                min="0"
                name="weight"
                onChange={this.handleInputChange}
                value={weight}
                label={i18n.t('taskWeight', { ns: 'taskManager' })}
                placeholder={i18n.t('taskWeight', { ns: 'taskManager' })}
                wrapperClassName="question-input-small"
              />
            )}
          </div>
        ) : (
          <div
            style={{
              display: 'none',
              margin: '0.5rem',
            }}
          >
            {task.deleteState && (
              <ChipContainer
                style={{ color: red, whiteSpace: 'nowrap' }}
                selected={false}
              >
                {i18n.t('deleted', { ns: 'taskManager' }) as string}
              </ChipContainer>
            )}
            <SanitizedHTML
              style={{
                marginInlineEnd: '15px',
                marginInlineStart: '15px',
                marginTop: '5px',
                marginBottom: '5px',
                width: '100%',
                color: task.deleteState ? red : black,
              }}
              html={'<b>' + title + '</b>'}
            />
            {task.haveWeight && (
              <Pill style={{ height: '1.2rem', width: '5rem' }}>
                {i18n.t('taskWeight', { ns: 'taskManager' }) +
                  ' : ' +
                  convertDigitToProperFormat(weight)}
              </Pill>
            )}
          </div>
        )}
        <TaskBody>
          {tab === 'info' && (
            <div
              id="info"
              className="row"
              style={{
                padding: '0 1rem ',
                margin: ' 0',
                overflowY: 'auto',
                overflowX: 'hidden',
                flex: '1',
                display: 'flex',
                flexWrap: 'wrap',
                alignContent: 'flex-start',
                gap: '1rem 0',
              }}
            >
              {fieldElements.bodyFields}
              {task.id > 0 && (
                <div style={{ width: '100%' }}>
                  <TaskAttachments
                    attachments={task.attachments}
                    editable={editing}
                    users={this.props.users}
                    conversationId={conversationId}
                    conversationToken={task.conversationSendToken!}
                    onDeleteAttachment={(id: number): void => {
                      this.deleteAttachment(id);
                    }}
                    onFileUploaded={(): void => {
                      setTimeout(
                        () => this.props.reFetchTask?.(this.props.task.id),
                        1000
                      );
                    }}
                  />
                </div>
              )}
              {relatedProviders &&
                (relatedProviderItems || haveRelatedItem) && (
                  <div style={{ width: '100%', padding: '0 0.25rem' }}>
                    {task && (
                      <TaskFilePicker
                        editable={editing && permission.edit}
                        items={relatedProviderItems}
                        onRemove={this.handleRemoveProviderItem}
                        onSave={this.handleSaveRelatedProviderItems}
                        providers={relatedProviders}
                        title={relatedProviderItemTitle}
                        task={task}
                        isRequired={this.listOfRequiredFields?.includes(
                          'relatedItem'
                        )}
                      />
                    )}
                  </div>
                )}
              <div
                className={'row col s12 m12 l12 xl12'}
                style={{ margin: 0, padding: 0 }}
              >
                {(haveAssignee || Object.values(assignee).length > 0) && (
                  <UsersList
                    ref={this.assigneeSectionRef}
                    id="task-assignees-section"
                    className="col s12 m12 l12"
                  >
                    <span
                      style={{
                        display: 'inline-block',
                        fontWeight: 'bold',
                        fontSize: '1rem',
                        paddingInlineStart: '0.25rem',
                        margin: '0.5rem 0',
                        color: absoluteBlack,
                      }}
                    >
                      {`${this.listOfRequiredFields?.includes('assignee') ? '*' : ''} ${messages.assignee(assigneeTitle)}
                    `}
                    </span>
                    {(() => {
                      const allDone = !Object.values(assignee).find(
                        (it) => it.progress !== 100
                      );
                      return (
                        // task.type === 'atOnce' &&
                        permission.mark &&
                        editing &&
                        Object.keys(assignee).length > 0 && (
                          <ProgressButton
                            onClick={() =>
                              this.handleSetAllProgressComplete(
                                allDone ? 'notStarted' : 'complete'
                              )
                            }
                          >
                            {messages.setAllAsA(
                              allDone
                                ? task.assigneeNotStartedTitle ||
                                    i18n.t('notStarted', { ns: 'taskManager' })
                                : task.assigneeCompleteTitle ||
                                    i18n.t('complete', { ns: 'taskManager' })
                            )}
                          </ProgressButton>
                        )
                      );
                    })()}
                    <UserSelector
                      usePop={true}
                      compact={!editing}
                      label={messages.assignee(assigneeTitle)}
                      onChangeValues={this.handleChangeAssignee}
                      values={Object.values(assignee)
                        .filter((value) => value.userId)
                        .reduce((list: IUserOption[], value) => {
                          const userMember = members[
                            `USER_${value.userId}`
                          ] as IUserOption;
                          const item: IUserOption = {
                            userId: value.userId,
                            name: userMember.name,
                            roles: userMember.roles,
                            progress: value.progress,
                            optionType: 'user',
                            progressDescription: value.progressDescription
                              ? value.progressDescription
                              : undefined,
                            status: value.status ? value.status : 'notStarted',
                            relatedRoleId: value.properties?.roleId,
                            relatedRoleName: value.properties?.roleName,
                            assignmentId: value?.id,
                          };
                          list.push(item);
                          return list;
                        }, [])}
                      options={Object.values(members)}
                      disable={!(editing && permission.edit)}
                      task={imTask}
                      onChangeProgress={this.handleChangeProgress}
                      type={type}
                      canChangeProgress={!lockMark && permission.mark && !draft}
                      canChangeSelfProgress={permission.markSelf && !draft}
                      permission={permission}
                      thisUserId={Number(this.props.thisUser.userId)}
                      projectMembers={projectMembersId}
                      projectName={project ? project.name : undefined}
                      allowAdd={true}
                      addMultipleMembersToCompany={
                        this.props.addMultipleMembersToCompany
                      }
                      companyId={companyId}
                      onSetAssignmentHistory={this.handleSetAssignmentHistory}
                      assigneeIdToShow={this.props.assigneeIdToShow}
                      onSetAssigneeIdToShow={this.props.onSetAssigneeIdToShow}
                    />
                  </UsersList>
                )}
                {haveFollower && (
                  <UsersList
                    className="col s12 m12 l12"
                    style={{
                      float: languageDirection() === 'rtl' ? 'right' : 'left',
                    }}
                  >
                    <span
                      style={{
                        display: 'inline-block',
                        fontWeight: 'bold',
                        fontSize: '1rem',
                        paddingInlineStart: '0.25rem',
                        margin: '0.5rem 0',
                        color: absoluteBlack,
                      }}
                    >
                      {`${task.requiredFields?.includes('follower') ? '*' : ''} ${messages.followers(followersTitle)}
                    `}
                    </span>
                    <UserSelector
                      usePop={true}
                      compact={!editing}
                      label={messages.followers(followersTitle)}
                      onChangeValues={this.handleChangeFollowers}
                      values={Object.values(followers).reduce(
                        (list: IUserOption[], value) => {
                          const userMember = members[
                            `USER_${value.userId}`
                          ] as IUserOption;
                          const item: IUserOption = {
                            userId: value.userId,
                            name: userMember?.name,
                            roles: userMember?.roles,
                            progressDescription:
                              userMember?.progressDescription,
                            optionType: 'user',
                          };
                          list.push(item);
                          return list;
                        },
                        []
                      )}
                      options={Object.values(members)}
                      disable={!(editing && permission.edit)}
                      canChangeProgress={false}
                      canChangeSelfProgress={false}
                      thisUserId={Number(this.props.thisUser.userId)}
                      task={imTask}
                      type={'noAssignment'}
                      projectMembers={projectMembersId}
                      projectName={project ? project.name : undefined}
                      onSetAssignmentHistory={this.handleSetAssignmentHistory}
                    />
                  </UsersList>
                )}
                {haveVerifier && (
                  <UsersList
                    className={fieldClass}
                    style={{
                      float: languageDirection() === 'rtl' ? 'right' : 'left',
                    }}
                  >
                    <span
                      style={{
                        display: 'inline-block',
                        fontWeight: 'bold',
                        fontSize: '1rem',
                        paddingInlineStart: '0.25rem',
                        margin: '0.5rem 0',
                        color: absoluteBlack,
                      }}
                    >
                      {`${task.requiredFields?.includes('assignee') ? '*' : ''} ${messages.verifier(verifierTitle)}
                    `}
                    </span>
                    <UserSelector
                      usePop={true}
                      label={messages.verifier(verifierTitle)}
                      onChangeValues={this.handleChangeVerifiers}
                      values={Object.values(verifiers).reduce(
                        (list: IUserOption[], value) => {
                          const userMember = members[
                            `USER_${value.userId}`
                          ] as IUserOption;
                          const item: IUserOption = {
                            userId: value.userId,
                            name: userMember.name,
                            roles: userMember.roles,
                            progress: value.progress,
                            optionType: 'user',
                            progressDescription: value.progressDescription
                              ? value.progressDescription
                              : undefined,
                            status: value.status ? value.status : 'notStarted',
                            relatedRoleId: value.properties?.roleId,
                            relatedRoleName: value.properties?.roleName,
                          };
                          list.push(item);
                          return list;
                        },
                        []
                      )}
                      options={Object.values(members).filter(
                        (option) => option.optionType === 'user'
                      )}
                      disable={!(editing && permission.edit)}
                      canChangeProgress={false}
                      onChangeProgress={this.handleChangeVerifyProgress}
                      task={imTask}
                      type={'noAssignment'}
                      onSetAssignmentHistory={this.handleSetAssignmentHistory}
                    />
                  </UsersList>
                )}
                {haveTaskPublisher && (
                  <UsersList
                    className={fieldClass}
                    style={{
                      float: languageDirection() === 'rtl' ? 'right' : 'left',
                    }}
                  >
                    <span
                      style={{
                        display: 'inline-block',
                        fontWeight: 'bold',
                        fontSize: '1rem',
                        paddingInlineStart: '0.25rem',
                        margin: '0.5rem 0',
                        color: absoluteBlack,
                      }}
                    >
                      {`${task.requiredFields?.includes('publisher') ? '*' : ''} ${messages.taskPublisher(taskPublisherTitle)}
                    `}
                    </span>
                    <UserSelector
                      usePop={true}
                      label={messages.taskPublisher(taskPublisherTitle)}
                      onChangeValues={this.handleChangeVerifier(
                        'taskPublish',
                        'taskPublisher'
                      )}
                      values={
                        taskPublisher
                          ? [
                              {
                                userId: taskPublisher.userId,
                                name: members[`USER_${taskPublisher.userId}`]
                                  ?.name,
                                progressDescription:
                                  taskPublisher.progressDescription,
                                roles: (
                                  members[
                                    `USER_${taskPublisher.userId}`
                                  ] as IUserOption
                                )?.roles,
                                optionType: 'user',
                                relatedRoleId: taskPublisher.properties?.roleId,
                                relatedRoleName:
                                  taskPublisher.properties?.roleName,
                              },
                            ]
                          : []
                      }
                      options={Object.values(members).filter(
                        (option) => option.optionType === 'user'
                      )}
                      disable={!(editing && permission.edit)}
                      canChangeProgress={permission.edit}
                      onChangeProgress={this.handleChangeVerifyProgress}
                      onSetAssignmentHistory={this.handleSetAssignmentHistory}
                      singleChoice={true}
                      task={imTask}
                      type={'noAssignment'}
                    />
                  </UsersList>
                )}
                {haveSubTaskPublisher && (
                  <UsersList
                    className={fieldClass}
                    style={{
                      float: languageDirection() === 'rtl' ? 'right' : 'left',
                    }}
                  >
                    <span
                      style={{
                        display: 'inline-block',
                        fontWeight: 'bold',
                        fontSize: '1rem',
                        paddingInlineStart: '0.25rem',
                        margin: '0.5rem 0',
                        color: absoluteBlack,
                      }}
                    >
                      {`${task.requiredFields?.includes('subtaskPublisher') ? '*' : ''} ${messages.subTaskPublisher(subTaskPublisherTitle)}`}
                    </span>
                    <UserSelector
                      usePop={true}
                      label={messages.subTaskPublisher(subTaskPublisherTitle)}
                      onChangeValues={this.handleChangeVerifier(
                        'subTaskPublish',
                        'subTaskPublisher'
                      )}
                      values={
                        subTaskPublisher
                          ? [
                              {
                                userId: subTaskPublisher.userId,
                                name: members[`USER_${subTaskPublisher.userId}`]
                                  ?.name,
                                progressDescription:
                                  subTaskPublisher.progressDescription,
                                roles: (
                                  members[
                                    `USER_${subTaskPublisher.userId}`
                                  ] as IUserOption
                                )?.roles,
                                optionType: 'user',
                                relatedRoleId:
                                  subTaskPublisher.properties?.roleId,
                                relatedRoleName:
                                  subTaskPublisher.properties?.roleName,
                              },
                            ]
                          : []
                      }
                      options={Object.values(members).filter(
                        (option) => option.optionType === 'user'
                      )}
                      disable={!(editing && permission.edit)}
                      canChangeProgress={permission.edit}
                      onChangeProgress={this.handleChangeVerifyProgress}
                      singleChoice={true}
                      task={imTask}
                      type={'noAssignment'}
                      onSetAssignmentHistory={this.handleSetAssignmentHistory}
                    />
                  </UsersList>
                )}
              </div>
              <div className={'row'} style={{ width: '100%' }}>
                <div
                  className={fieldClass}
                  style={{
                    margin: 0,
                    float: languageDirection() === 'rtl' ? 'right' : 'left',
                  }}
                >
                  {haveVerifyDate && (
                    <MultiDatePicker
                      isEditable={editing && permission.edit}
                      hasTime={dateAndTime}
                      label={
                        i18n.t('verifyDate', { ns: 'taskManager' }) as string
                      }
                      value={verifyDate}
                      setDate={(value) => {
                        this.setDate({ verifyDate: value });
                      }}
                    />
                  )}
                  {haveStartDate ? (
                    haveDueDate ? (
                      dateAndTime ? (
                        <MultiDatePicker
                          isEditable={editing && permission.edit}
                          hasTime={true}
                          isWithDuration={true}
                          label={`${task.requiredFields?.includes('startDate') || this.listOfRequiredFields?.includes('dueDate') ? '*' : ''} ${
                            startDateTitle
                              ? startDateTitle
                              : (i18n.t('startDate', {
                                  ns: 'taskManager',
                                }) as string)
                          }
                           - ${dueDateTitle ? dueDateTitle : i18n.t('dueDate', { ns: 'taskManager' })}`}
                          value={{
                            startDate: startDate as number,
                            dueDate: dueDate as number,
                          }}
                          setDate={this.setDate}
                        />
                      ) : (
                        <MultiDatePicker_Range
                          isEditable={editing && permission.edit}
                          hasTime={dateAndTime}
                          label={`${task.requiredFields?.includes('startDate') || this.listOfRequiredFields?.includes('dueDate') ? '*' : ''} ${
                            startDateTitle
                              ? startDateTitle
                              : i18n.t('startDate', { ns: 'taskManager' })
                          } - ${dueDateTitle ? dueDateTitle : i18n.t('dueDate', { ns: 'taskManager' })}`}
                          values={{
                            startDate: startDate as number,
                            dueDate: dueDate as number,
                          }}
                          setDate={this.setDate}
                        />
                      )
                    ) : (
                      <MultiDatePicker
                        isEditable={editing && permission.edit}
                        hasTime={dateAndTime}
                        label={`${task.requiredFields?.includes('startDate') ? '*' : ''} ${
                          startDateTitle
                            ? startDateTitle
                            : i18n.t('startDate', { ns: 'taskManager' })
                        }`}
                        value={startDate as number}
                        setDate={(value) => {
                          this.setDate({ startDate: value });
                        }}
                      />
                    )
                  ) : haveDueDate ? (
                    <MultiDatePicker
                      isEditable={editing && permission.edit}
                      hasTime={dateAndTime}
                      label={`${task.requiredFields?.includes('dueDate') ? '*' : ''} ${
                        dueDateTitle
                          ? dueDateTitle
                          : i18n.t('dueDate', { ns: 'taskManager' })
                      }`}
                      value={dueDate as number}
                      setDate={(value) => {
                        this.setDate({ dueDate: value });
                      }}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className={'row'} style={{ width: '100%' }}>
                {task.haveRelatedTask && (
                  <div className={'col s12 m12 l12'} style={{ margin: 0 }}>
                    <SubTaskListWrapper id={`subtask${task.id}`} halve={false}>
                      <RelatedTasksComponent
                        task={task}
                        editing={editing}
                        companyId={companyId}
                        handleClickOnTask={handleClickOnTask}
                        onRelatedTasksChange={(newRelatedTasks) => {
                          this.setState({ newRelatedTasks });
                          if (this.props.editing) {
                            this.setDirty();
                          }
                        }}
                        onUpdateAssignment={onUpdateAssignment}
                        onUpdateTask={onUpdateTask}
                        windowSize={windowSize}
                      />
                    </SubTaskListWrapper>
                  </div>
                )}
              </div>
              <div className={'row'} style={{ width: '100%' }}>
                {task.haveSubTask &&
                  templates &&
                  (!task.draft || !task.preventSubTaskCreationWhenDraft) && (
                    <div className={'col s12 m12 l12'} style={{ margin: 0 }}>
                      <SubTaskListWrapper
                        id={`subtask${task.id}`}
                        halve={false}
                      >
                        <SubtaskListContainer
                          visible={true}
                          task={task}
                          templates={templates}
                          onUpdateTask={onUpdateTask}
                          canEditSubtasks={permission.create}
                          handleClickOnTask={handleClickOnTask}
                          onUpdateAssignment={onUpdateAssignment}
                          companyId={companyId}
                          members={members}
                          project={project}
                          title={messages.subtasks(subTasksTitle) || ''}
                          selectedSubTaskId={this.props.selectedSubTaskId}
                          windowSize={windowSize}
                        />
                        <HighlightOverlay
                          visible={this.state.highlightSubtasks}
                        />
                      </SubTaskListWrapper>
                    </div>
                  )}
              </div>
              <div className={'row col s12 m12 l12 xl12'} style={{ margin: 0 }}>
                {(template ||
                  editing ||
                  assigneeChanged ||
                  fieldElements.progressFields.length ||
                  (task.draft && haveTaskPublisher) ||
                  (!task.draft && haveSubTaskPublisher && foundDraftSubtask) ||
                  (template && !task.draft) ||
                  taskIsReadyToPublish) && (
                  <SaveTaskActions isCreating={!task.id}>
                    <div className={'row'}>{fieldElements.progressFields}</div>
                    {showTaskIsReadyPublishCheckbox && (
                      <Input
                        id="taskIsReadyPublish"
                        type="checkbox"
                        name="taskIsReadyPublish"
                        label={messages.readyPublishTask(
                          readyToPublishTaskTitle,
                          task.taskName
                        )}
                        disabled={!editing}
                        checked={taskIsReadyToPublish}
                        onChange={this.handleTaskIsReadyToPublishChange}
                        className="row"
                      />
                    )}
                    {showSubTasksArReadyToPublishCheckbox && (
                      <>
                        <Input
                          id={`${task.id}subTasksAreReadyToPublish`}
                          type="checkbox"
                          name="subTasksAreReadyToPublish"
                          label={messages.readyPublishSubTask(
                            readyToPublishSubTaskTitle,
                            task.subTasksTitle
                          )}
                          disabled={!editing}
                          checked={subTasksAreReadyToPublish}
                          onChange={this.handleSubTasksAreReadyToPublishChange}
                          className="row"
                        />
                      </>
                    )}
                    {showLockCheckbox && (
                      <>
                        <Input
                          id={`${task.id}lock`}
                          type="checkbox"
                          name="lockProps"
                          label={messages.lockTask}
                          disabled={!editing}
                          checked={this.state.task.lockProps}
                          onChange={this.handleChangeLock}
                          className="row"
                        />
                      </>
                    )}
                    {(template || editing || assigneeChanged) && (
                      <ButtonActions>
                        <Button color="red" onClick={this.onCancel}>
                          {i18n.t('cancel', { ns: 'taskManager' }) as string}
                        </Button>
                        <div style={{ flex: 1 }}></div>
                        {taskHasSMSHandler && (
                          <Input
                            id={'disableSendSMS'}
                            type="checkbox"
                            label={
                              i18n.t('disableSendingSMS', {
                                ns: 'taskManager',
                              }) as string
                            }
                            checked={this.state.disableSendSMS}
                            onChange={(e: any) => {
                              this.setState({
                                disableSendSMS: e.target.checked,
                              });
                            }}
                          />
                        )}
                        <Button
                          color="green"
                          onClick={this.handleSave}
                          loading={loadingSave}
                          disabled={
                            !title ||
                            (hasEmptyRequiredField && !draft) ||
                            (dueDate && startDate ? dueDate < startDate : false)
                          }
                        >
                          {saveButtonTitle}
                        </Button>
                      </ButtonActions>
                    )}
                  </SaveTaskActions>
                )}
              </div>
              {!template && (
                <TaskFooter className="flex gap-5 w-full">
                  <APopover
                    arrow={true}
                    curveBorder={true}
                    trigger="click"
                    target={
                      <div>
                        <LocalIcon
                          iconName="notification.svg"
                          color={orange}
                          style={{ margin: '0.5rem 0' }}
                        />
                      </div>
                    }
                  >
                    <table className="px-5">
                      {remindersConfig.map((item, ind) => {
                        return (
                          <tr key={ind}>
                            <th className="flex m-2">
                              {
                                i18n.t('reminderTo', {
                                  ns: 'taskManager',
                                  user: item.sendTo,
                                }) as string
                              }
                            </th>
                            <td className="px-2">
                              {
                                i18n.t('reminderTimeTargetTime', {
                                  ns: 'taskManager',
                                  time: item.time,
                                  targetTimeTitle: item.targetTime,
                                }) as string
                              }
                            </td>
                          </tr>
                        );
                      })}
                    </table>
                  </APopover>
                  <p className="flex-1 flex items-center">
                    {task.creationDate &&
                      (i18n.t('createdByIn', {
                        ns: 'taskManager',
                        name: (members[`USER_${task.creator}`] || { name: '' })
                          .name,
                        date: smartDateString(
                          new Date(task.creationDate),
                          true,
                          true
                        ),
                      }) as string)}
                  </p>
                </TaskFooter>
              )}
            </div>
          )}
          {!template && tab === 'conversation' && (
            <TaskConversation
              readToken={task.conversationReadToken}
              sendToken={task.conversationSendToken}
              conversationId={conversationId}
              projectId={task.projectId}
              messageSent={(msg: any) => {
                if (msg.type === 'file')
                  this.props.reFetchTask?.(this.props.task.id);
              }}
            />
          )}
        </TaskBody>
      </div>
    );
  }

  private getFieldElements(
    fields: IField[],
    editing: boolean,
    autoFillLoading: Set<string>,
    task: ITask,
    project: IProjectStore | undefined,
    progressChanged: boolean,
    fieldClass: string
  ) {
    const ret = {
      bodyFields: [] as any[],
      progressFields: [] as any[],
    };
    fields?.forEach((field, index) => {
      if (field.value === HiddenFieldValue) return;
      const target =
        field.relatedToProgress || field.highlight
          ? ret.progressFields
          : ret.bodyFields;
      const disabled = !(
        editing ||
        (field.relatedToProgress && progressChanged)
      );
      if (field.type === 'html') {
        target.push(
          <div className="col s12 m12 l12 my-5" style={{ padding: '0' }}>
            <CKEditorField
              key={field.name}
              id={field.name}
              label={
                <div
                  style={{
                    margin: '2px 0px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    fontWeight: 'bold',
                    fontSize: '1rem',
                    paddingInlineStart: '0.5rem',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    {field.required &&
                      (editing ||
                        (field.relatedToProgress && progressChanged) ||
                        !field.value ||
                        /^\s*$/.test(field.value)) && (
                        <img
                          src={required}
                          className={
                            !field.value || /^\s*$/.test(field.value)
                              ? 'filter-red'
                              : ''
                          }
                          style={{
                            padding: '7px',
                          }}
                        />
                      )}
                    <div>{field.title}</div>
                  </div>
                  {!disabled && (
                    <div className="flex items-center gap-1">
                      {field.autoFillFunc === 'ConvertVoiceToMeetingNote' ? (
                        <VoiceToText
                          onFillText={(text: string) =>
                            this.handleChangeFieldValue(index, text)
                          }
                        />
                      ) : field.autoFillFunc ? (
                        <Button
                          style={{ padding: '2px 4px' }}
                          color="green"
                          onClick={() => this.autoFill(index, field)}
                          loading={autoFillLoading.has(field.name)}
                        >
                          {i18n.t('autoFill', { ns: 'taskManager' }) as string}
                        </Button>
                      ) : (
                        <></>
                      )}
                    </div>
                  )}
                </div>
              }
              // editor={ClassicEditor}
              data={field?.value || ''}
              onReady={(editor: any) => {
                this.addEditor(editor, field.name);
              }}
              disabled={disabled}
              // updateContent={(data: string) => {
              //   this.handleChangeFieldValue(index, data);
              // }}
              onChange={(data: any, _: any) => {
                this.handleChangeFieldValue(index, data);
                // this.addEditor(editor, field.name);
              }}
              onFocus={(_: any, editor: any) => {
                this.addEditor(editor, field.name);
              }}
              language={getLanguageBaseOnTZ()}
              dir={languageDirection()}
              config={CkEditorBaseConfig(this.props.token)}
            />
          </div>
        );
      } else {
        const allFieldOptions = getAllFieldOptions(
          task,
          field,
          this.props.tasks,
          project!
        );
        const label = (
          <label className="flex items-center gap-1">
            {field.required &&
              (editing ||
                (!editing && (!field.value || /^\s*$/.test(field.value))) ||
                (field.relatedToProgress && progressChanged)) && (
                <img
                  src={required}
                  className={
                    !field.value || /^\s*$/.test(field.value)
                      ? 'filter-red'
                      : ''
                  }
                  style={{
                    padding: ' 0 7px',
                    marginBottom: '-3px',
                  }}
                />
              )}
            <div>{field.title}</div>
            {editing && field.autoFillFunc && (
              <>
                <span className="flex-1" />
                <Button
                  style={{ padding: '2px 4px' }}
                  color="green"
                  onClick={() => this.autoFill(index, field)}
                  loading={autoFillLoading.has(field.name)}
                >
                  {i18n.t('autoFill', { ns: 'taskManager' }) as string}
                </Button>
              </>
            )}
          </label>
        );
        if (!disabled) {
          target.push(
            <div
              key={index}
              className={fieldClass}
              style={{ display: 'flex', margin: 0 }}
            >
              {field.options && allFieldOptions.length > 0 ? (
                <Select
                  containerStyle={{ flexGrow: 1 }}
                  label={label}
                  values={(field.type === 'multiSelect'
                    ? (field.value || '').split(',')
                    : [field.value || '']
                  ).reduce((current: IOption[], item) => {
                    if (item)
                      current.push({
                        label: item,
                        value: item,
                      });
                    return current;
                  }, [] as IOption[])}
                  options={allFieldOptions.reduce(
                    (current: IOption[], item) => {
                      current.push({
                        label: item,
                        value: item,
                      });
                      return current;
                    },
                    [] as IOption[]
                  )}
                  onChangeValues={(values) =>
                    this.handleChangeFieldValues(index, values)
                  }
                  multiChoice={field.type === 'multiSelect'}
                />
              ) : field.type === 'date' ? (
                <>
                  <MultiDatePicker
                    className="roundDateInputInTask"
                    id={field.name}
                    style={{ flexGrow: 1, width: '100%' }}
                    value={
                      fields[index] && Number(fields[index].value)
                        ? Number(fields[index].value)
                        : undefined
                    }
                    label={label}
                    setDate={(value) =>
                      this.handleDateFieldChangeEvent(index.toString(), value)
                    }
                    isEditable={editing && this.props.permission.edit}
                  />
                </>
              ) : (
                <Input
                  type="text"
                  className=""
                  key={index}
                  id={field.name}
                  name={index.toString()}
                  value={fields[index] ? fields[index].value || '' : ''}
                  onChange={this.handleFieldChangeEvent}
                  label={label}
                  placeholder={field.title}
                  style={{
                    minHeight: '2.5rem',
                    height: '2.5rem',
                  }}
                  wrapperStyle={{
                    flexGrow: 1,
                  }}
                />
              )}
            </div>
          );
        } else {
          target.push(
            <div className={fieldClass} key={index} style={{ margin: 0 }}>
              <label className="flex items-center gap-1">
                {field.required &&
                  (editing ||
                    (!editing &&
                      (!field.value || /^\s*$/.test(field.value)))) && (
                    <img
                      src={required}
                      className={
                        !field.value || /^\s*$/.test(field.value)
                          ? 'filter-red'
                          : ''
                      }
                      style={{
                        padding: ' 0 7px',
                        marginBottom: '-3px',
                      }}
                    />
                  )}
                <div>{field.title}</div>
              </label>
              <InputValueWrapper>
                {allFieldOptions.length > 0 ? (
                  <div style={{ display: 'inline-block' }}>
                    {field.value &&
                      field.value?.split(',').map((part, index) => {
                        return (
                          <Badge
                            hollow={false}
                            radius={10}
                            color={stringToColour(
                              field.name,
                              1,
                              null,
                              field?.value || undefined
                            )}
                            textColor="var(--exact-white)"
                            key={index}
                            style={{ margin: '2px 2px' }}
                          >
                            {part}
                          </Badge>
                        );
                      })}
                  </div>
                ) : field.type === 'date' ? (
                  <span style={{ whiteSpace: 'pre-wrap', color: gray }}>
                    {fields[index].value && Number(fields[index].value)
                      ? smartDateString(
                          Number(fields[index].value),
                          false,
                          true,
                          true
                        )
                      : fields[index].value || ''}
                  </span>
                ) : (
                  <span style={{ whiteSpace: 'pre-wrap', color: gray }}>
                    {fields[index] ? fields[index].value : ''}
                  </span>
                )}
              </InputValueWrapper>
            </div>
          );
        }
      }
    });
    return ret;
  }
}

export default TaskEditor;
